export default __webpack_public_path__ + "static/media/maria-castellano.afc61ddb.jpeg";